import { useState, useEffect } from 'react';
import useDataBean from '../../../core/services/dataBean/useDataBean';
import { _ManufacturingStardard } from '../../../core/services/dataBean/EntityCatalog';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
}

export const SelectManufacturingStandars = ({ idSelector, onChange, label, returnType = "ID" }: Props) => {

    const { instance, lista, setLista } = useDataBean(_ManufacturingStardard)
    const [id, setID] = useState(null);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDManufacturingStardard == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                console.warn("Elemento no encontrado para ID:", e);
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };

    const getLista = () => {
        instance.getManufacturingStardardByCode(null, null, null, null, null)
            .then((resp: any) => {
                if (Array.isArray(resp.List)) {
                    setLista(resp.List);
                } else {
                    console.warn("La respuesta no es un arreglo:", resp);
                    setLista([]);
                }
            })
            .catch(err => {
                console.error("Error al obtener la lista:", err);
                setLista([]); // En caso de error, asegúrate de que `lista` sea un arreglo vacío
            });
    };


    return (
        <>
            <label>{label ?? "Tipos de Labor"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={null}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDManufacturingStardard} >{item.DataBeanProperties.IDManufacturingStardard} - {item.DataBeanProperties.ProductiveProcessTypeName}</option>
                        )
                    })
                }
            </select>
        </>
    )
}